export enum BasicInfoType {
    standard = 'standard',
    testSeries = 'testSeries',
    comboCourse = 'comboCourse'
}